
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import styles from "../css/CreateReports.module.css";
import { FormikProps } from "formik";
import {  useEffect, useState } from "react";
// Define an interface for props

interface FormValues {
  graphName: string;
  report: string;
  graph: string;
  ejex: string;
  ejey: string;
  rangoxmin: string;
  rangoxmax: string;
  rangoymin: string;
  rangoymax: string;
}

interface MyComponentProps {
  graph: string;
  reportColumns: string[];
  formik: FormikProps<FormValues>;
  firstRow: any;
}

interface Fields {
  reportColumns: string[];
  formik: FormikProps<FormValues>;
  firstRow: any;
}


// Define the component map (using string literals for keys)
const componentMap: { [key: string]: React.ComponentType<Fields>} = {
  histogram: ComponentForABCandD,
  lollipop: ComponentForABCandD,
  pie: ComponentForABCandD,
  donut: ComponentForABCandD,
  circularBar: ComponentForABCandD,
  density: ComponentForEandF,
  rid: ComponentForK,
  box: ComponentForK,
  scatter: Component2D,
  density2d: Component2D,
};
const ExtraFileds = ({graph, reportColumns, formik, firstRow}: MyComponentProps) => {
  
  //console.log("After elimination:", firstRow);
  //console.log('graph',graph);
  // Determine which component to render based on graph
  const ComponentToRender = componentMap[graph] || DefaultComponent;
  //console.log("columns", reportColumns)
  //console.log("formikestra", formik)
  //console.log("row", firstRow)
  return (
      <ComponentToRender reportColumns={reportColumns} formik={formik} firstRow={firstRow} />
  );
}


// Define your component for a, b, c, d
function ComponentForABCandD({reportColumns, firstRow, formik}:Fields) {
 const [filteredColumns, setFilteredColumns] = useState<string[]>([]);
 const [loading,setLoading]= useState(true);
  useEffect(() => {
    if (!reportColumns || !firstRow){ 
     setFilteredColumns([])
     return;}     
    // Filter the reportColumns array
    setLoading(true);
    const filtered = filterColumns(reportColumns, column =>
      typeof firstRow[column] === "string" &&
      !["Fecha Inicio", 'Fecha de ingreso', 'Fecha Fin', 'Descripción', 'Empleado'].includes(column)
    );

    setFilteredColumns(filtered);
    setLoading(false)
  }, [reportColumns, firstRow]);

 const noCompatibleColumns = !loading && filteredColumns.length === 0;
 const handleChangeDatosx = (event: any) => {
  const str = event.target.value as string
  formik.setFieldValue("ejex", str);
 }
 
 // dona, pastel 
  return (
    <div className={styles.formControlContainer}>
      <FormControl
        size="small"
        variant="outlined"
        fullWidth
      >
        <InputLabel id="ejex-label" className={styles.formLabel}>Serie de datos*</InputLabel>
        <Select
          onChange={handleChangeDatosx}
          value={formik.values.ejex}
          labelId="ejex-label"
          id="ejex"
          name="ejex"
          label="Serie de datos*"
          error={formik.touched.ejex && Boolean(formik.errors.ejex)}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: 'left'
            },
            getContentAnchorEl: null,
          }}
        >
          {filteredColumns?.map( (item: any) => <MenuItem key={`${item}Id`} value={item}> {item} </MenuItem>)}
        </Select>

        <FormHelperText style={{ color: "red" }}>
        {formik.touched.ejex && formik.errors.ejex 
          }
          {loading
            ? null
            : (reportColumns.length > 0 && noCompatibleColumns) && 
            'Este informe no contiene columnas compatibles con este tipo de gráfico'}
          
        </FormHelperText>
      </FormControl>   
    </div>
    
  );
}

// component for densidad
function ComponentForEandF({reportColumns, formik, firstRow}:Fields) {
  
  const [filteredColumns, setFilteredColumns] = useState<string[]>([]);
  const [loading,setLoading]= useState(true);
  useEffect(() => {
    if (!reportColumns || !firstRow){ 
     setFilteredColumns([])
     return;}    
    // Filter the reportColumns array
    setLoading(true);
    const filtered = filterColumns(reportColumns, column =>
      typeof firstRow[column] === "number" &&
      !['ID','ID Nómina', 'ID Empleado', 'ID Nómina Colaborador' , 'id Nómina', 'id de Nómina'].includes(column)
    );

    setFilteredColumns(filtered);
    setLoading(false)
  }, [reportColumns, firstRow]);
  
  const handleChangeDatosx = (event: any) => {
    const str = event.target.value as string
    formik.setFieldValue("ejex", str);
   }
  
   const handleChangeTexfield = (event:any) => {
    const inputValue = event.target.value;
    // Check if the input is a valid integer
    if (/^-?$|^0$|^-?[1-9]\d*$/.test(inputValue)) {
      formik.setFieldValue(event.target.name, inputValue)
    }
  };
  const noCompatibleColumns = !loading && filteredColumns.length === 0;
  return (
    <div  style={{ display: 'flex', justifyContent :'space-between', marginTop: '12px'}} >
      <FormControl
        size="small"
        variant="outlined"
        style={{
          width: '30%'
        }}
      >
        <InputLabel id="ejex-label" className={styles.formLabel}>
          Serie de datos*
        </InputLabel>
        <Select
          onChange={handleChangeDatosx}
          value={formik.values.ejex}
          labelId="ejex-label"
          id="ejex"
          name="ejex"
          label='Serie de datos*'
          error={formik.touched.ejex && Boolean(formik.errors.ejex)}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: 'left'
            },
            getContentAnchorEl: null,
          }}
        >
          {filteredColumns?.map( (item: any) => <MenuItem key={`${item}Id`} value={item}> {item} </MenuItem>)}
        </Select>

        <FormHelperText style={{ color: "red" }}>
          {formik.touched.ejex && formik.errors.ejex 
          }
          {loading
            ? null
            : (reportColumns.length > 0 && noCompatibleColumns) && 
            'Este informe no contiene columnas compatibles con este tipo de gráfico'}
        </FormHelperText>
      </FormControl>

    
      <TextField
      name="rangoxmin"
      label="Límite mínimo de la serie*"
      variant="outlined"
      size="small"
      onBlur={formik.handleBlur}
      onChange={handleChangeTexfield}
      value={formik.values.rangoxmin}
      placeholder="-1000"
      error={formik.touched.rangoxmin && Boolean(formik.errors.rangoxmin)}
      helperText={formik.touched.rangoxmin && formik.errors.rangoxmin}
      FormHelperTextProps={{ style: { color: 'red' } }}
      inputProps={{ maxLength: 24 }}
      InputLabelProps={{
        classes:{
          root: styles.label,
          shrink: styles["label-shrinked"]
        }
      }}
      style={{width: '30%'}}
      />
  
      <TextField
      name="rangoxmax"
      label="Límite máximo de la serie*"
      variant="outlined"
      size="small"
      onBlur={formik.handleBlur}
      onChange={handleChangeTexfield}
      value={formik.values.rangoxmax}
      placeholder="1000"
      error={formik.touched.rangoxmax && Boolean(formik.errors.rangoxmax)}
      helperText={formik.touched.rangoxmax && formik.errors.rangoxmax}
      FormHelperTextProps={{ style: { color: 'red' } }}
      inputProps={{ maxLength: 24 }}
      InputLabelProps={{
        classes:{
          root: styles.label,
          shrink: styles["label-shrinked"]
        }
      }}
      style={{width: '30%'}}
      />

    </div>
  );
}

//  component for Box y ridline
function ComponentForK({reportColumns, formik, firstRow}:Fields) {

  const [filteredColumnsNotNum, setFilteredColumnsNotNum] = useState<string[]>([]);
  const [filteredColumnsNum, setFilteredColumnsNum] = useState<string[]>([]);
  const [loading,setLoading]= useState(true);
  
  useEffect(() => {
    if (!reportColumns || !firstRow){ 
     setFilteredColumnsNotNum([])
     setFilteredColumnsNum([])
     return;
    }    
    // Filter the reportColumns array
    setLoading(true);
    const filtered = filterColumns(reportColumns, column =>
      typeof firstRow[column] === "string" &&
      !["Fecha Inicio", 'Fecha de ingreso', 'Fecha Fin', 'Descripción'].includes(column)
    );

    const filteredNum = filterColumns(reportColumns, column =>
      typeof firstRow[column] === "number" &&
      !['ID','ID Nómina', 'ID Empleado', 'ID Nómina Colaborador' , 'id Nómina', 'id de Nómina'].includes(column)
    );

    setFilteredColumnsNotNum(filtered);
    setFilteredColumnsNum(filteredNum);
    setLoading(false)
  }, [reportColumns, firstRow]);

  
  const handleChangeDatosx = (event: any) => {
    const str = event.target.value as string
    formik.setFieldValue("ejex", str);
   }
  
   const handleChangeDatosy = (event: any) => {
    const str = event.target.value as string
    formik.setFieldValue("ejey", str);
   }

   const handleChangeTexfield = (event:any) => {
    const inputValue = event.target.value;
    // Check if the input is a valid integer
    if (/^-?$|^0$|^-?[1-9]\d*$/.test(inputValue)) {
      formik.setFieldValue(event.target.name, inputValue)
    }
  };
  const noCompatibleColumnsNum = !loading && filteredColumnsNum.length === 0;
  const noCompatibleColumns = !loading && filteredColumnsNotNum.length === 0;
  return(
    <div>
      
      <div style={{ display: 'flex', justifyContent :'space-between', marginTop: '12px'}} >
        
        <FormControl
          size="small"
          variant="outlined"
          style={{
            width: '30%'
          }}
        >
          <InputLabel id="ejex-label" className={styles.formLabel}>
            Serie de datos*
          </InputLabel>
          <Select
            onChange={handleChangeDatosx}
            value={formik.values.ejex}
            labelId="ejex-label"
            id="ejex"
            name="ejex"
            label="Serie de datos*"
            error={formik.touched.ejex && Boolean(formik.errors.ejex)}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: 'left'
              },
              getContentAnchorEl: null,
            }}
          >
            
            {filteredColumnsNum?.map( (item: any) => <MenuItem key={`${item}Id`} value={item}> {item} </MenuItem>)}
          </Select>

          <FormHelperText style={{ color: "red" }}>
            {formik.touched.ejex && formik.errors.ejex}
            {loading
            ? null
            : (reportColumns.length > 0 && noCompatibleColumnsNum) && 
            'Este informe no contiene columnas compatibles con este tipo de gráfico'}
          </FormHelperText>
        </FormControl>
        
        
        <TextField
        name="rangoxmin"
        label="Límite mínimo de la serie*"
        variant="outlined"
        size="small"
        onBlur={formik.handleBlur}
        onChange={handleChangeTexfield}
        value={formik.values.rangoxmin}
        placeholder="-1000"
        error={formik.touched.rangoxmin && Boolean(formik.errors.rangoxmin)}
        helperText={formik.touched.rangoxmin && formik.errors.rangoxmin}
        FormHelperTextProps={{ style: { color: 'red' } }}
        inputProps={{ maxLength: 24 }}
        InputLabelProps={{
          classes:{
            root: styles.label,
            shrink: styles["label-shrinked"]
          }
        }}
        style={{width: '30%'}}
        />

        <TextField
        name="rangoxmax"
        label="Límite máximo de la serie*"
        variant="outlined"
        size="small"
        onBlur={formik.handleBlur}
        onChange={handleChangeTexfield}
        value={formik.values.rangoxmax}
        placeholder="1000"
        error={formik.touched.rangoxmax && Boolean(formik.errors.rangoxmax)}
        helperText={formik.touched.rangoxmax && formik.errors.rangoxmax}
        FormHelperTextProps={{ style: { color: 'red' } }}
        inputProps={{ maxLength: 24 }}
        InputLabelProps={{
          classes:{
            root: styles.label,
            shrink: styles["label-shrinked"]
          }
        }}
        style={{width: '30%'}}
        />
      </div>

      <FormControl
        size="small"
        variant="outlined"
        fullWidth
        style={{marginTop: '12px'}}
      >
        <InputLabel id="ejey-label" className={styles.formLabel}>
          Segunda serie de datos no numérica*
        </InputLabel>
        <Select
          onChange={handleChangeDatosy}
          value={formik.values.ejey}
          labelId="ejey-label"
          id="ejey"
          name="ejey"
          label="Segunda serie de datos no numérica*"
          error={formik.touched.ejey && Boolean(formik.errors.ejey)}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: 'left'
            },
            getContentAnchorEl: null,
          }}
        >
          {filteredColumnsNotNum?.map( (item: any) => <MenuItem key={`${item}Id`} value={item}> {item} </MenuItem>)}
        </Select>

        <FormHelperText style={{ color: "red" }}>
          {formik.touched.ejey && formik.errors.ejey}
          {loading
            ? null
            : (reportColumns.length > 0 && noCompatibleColumns) 
            && 'Este informe no contiene columnas compatibles con este tipo de gráfico'}
        </FormHelperText>
      </FormControl>

    </div>
  );
}

//Component for hexbin and dispersión
function Component2D({reportColumns, formik, firstRow}:Fields){
  const [filteredColumns, setFilteredColumns] = useState<string[]>([]);
  const [loading,setLoading]= useState(true);
  useEffect(() => {
    if (!reportColumns || !firstRow){ 
     setFilteredColumns([])
     return;}    
    // Filter the reportColumns array
    setLoading(true);
    const filtered = filterColumns(reportColumns, column =>
      typeof firstRow[column] === "number" &&
      !['ID','ID Nómina', 'ID Empleado', 'ID Nómina Colaborador' , 'id Nómina', 'id de Nómina'].includes(column)
    );

    setFilteredColumns(filtered);
    setLoading(false)
  }, [reportColumns, firstRow]);


  const handleChangeDatosx = (event: any) => {
    const str = event.target.value as string
    formik.setFieldValue("ejex", str);
   }
  
   const handleChangeDatosy = (event: any) => {
    const str = event.target.value as string
    formik.setFieldValue("ejey", str);
   }
  
   const handleChangeAAA = (event:any) => {
    const inputValue = event.target.value;
    // Check if the input is a valid integer
    if (/^-?$|^0$|^-?[1-9]\d*$/.test(inputValue)) {
      formik.setFieldValue(event.target.name, inputValue)
    }
  };
  const noCompatibleColumns = !loading && filteredColumns.length === 0;
  return(
    <div>
      
      <div style={{ display: 'flex', justifyContent :'space-between', marginTop: '12px'}}>
        <FormControl
          size="small"
          variant="outlined"
          style={{
            width: '30%'
          }}
        >
          <InputLabel id="ejex-label" className={styles.formLabel}>
            Serie de datos en x*
          </InputLabel>
          <Select
            className={styles.select}
            onChange={handleChangeDatosx}
            value={formik.values.ejex}
            labelId="ejex-label"
            id="ejex"
            name="ejex"
            label='Serie de datos en x*'
            error={formik.touched.ejex && Boolean(formik.errors.ejex)}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: 'left'
              },
              getContentAnchorEl: null,
            }}
          >
            {filteredColumns?.map( (item: any) => <MenuItem key={`${item}Id`} value={item}> {item} </MenuItem>)}
          </Select>

          <FormHelperText style={{ color: "red" }}>
          {formik.touched.ejex && formik.errors.ejex 
          }
          {loading
            ? null
            : (reportColumns.length > 0 && noCompatibleColumns) && 
            'Este informe no contiene columnas compatibles con este tipo de gráfico'}
          </FormHelperText>
        </FormControl>
        
        <TextField
        name="rangoxmin"
        label="Límite mínimo serie x*"
        variant="outlined"
        size="small"
        fullWidth={true}
        onBlur={formik.handleBlur}
        onChange={handleChangeAAA}
        value={formik.values.rangoxmin}
        placeholder="-1000"
        error={formik.touched.rangoxmin && Boolean(formik.errors.rangoxmin)}
        helperText={formik.touched.rangoxmin && formik.errors.rangoxmin}
        FormHelperTextProps={{ style: { color: 'red' } }}
        inputProps={{ maxLength: 24 }}
        InputLabelProps={{
          classes:{
            root: styles.label,
            shrink: styles["label-shrinked"]
          }
        }}
        style={{width: '30%'}}
        />

        <TextField
        name="rangoxmax"
        label="Límite máximo serie x*"
        variant="outlined"
        size="small"
        fullWidth={true}
        onBlur={formik.handleBlur}
        onChange={handleChangeAAA}
        value={formik.values.rangoxmax}
        placeholder="1000"
        error={formik.touched.rangoxmax && Boolean(formik.errors.rangoxmax)}
        helperText={formik.touched.rangoxmax && formik.errors.rangoxmax}
        FormHelperTextProps={{ style: { color: 'red' } }}
        inputProps={{ maxLength: 24 }}
        InputLabelProps={{
          classes:{
            root: styles.label,
            shrink: styles["label-shrinked"]
          }
        }}
        style={{width: '30%'}}
        />
      </div>

      <div style={{ display: 'flex', justifyContent :'space-between', marginTop: '12px'}}>
        <FormControl
          size="small"
          variant="outlined"
          style={{
            width: '30%'
          }}
        >
          <InputLabel id="ejey-label" className={styles.formLabel}>
            Serie de datos en y*
          </InputLabel>
          <Select
            onChange={handleChangeDatosy}
            value={formik.values.ejey}
            labelId="ejey-label"
            id="ejey"
            name="ejey"
            label='Serie de datos en y*'
            error={formik.touched.ejey && Boolean(formik.errors.ejey)}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: 'left'
              },
              getContentAnchorEl: null,
            }}
          >
            {filteredColumns?.map( (item: any) => <MenuItem key={`${item}Id`} value={item}> {item} </MenuItem>)}
          </Select>

          <FormHelperText style={{ color: "red" }}>
          {formik.touched.ejey && formik.errors.ejey 
          }
          {loading
            ? null
            : (reportColumns.length > 0 && noCompatibleColumns) && 
            'Este informe no contiene columnas compatibles con este tipo de gráfico'}
          </FormHelperText>
        </FormControl>

        <TextField
        name="rangoymin"
        label="Límite mínimo serie y*"
        variant="outlined"
        size="small"
        fullWidth={true}
        onBlur={formik.handleBlur}
        onChange={handleChangeAAA}
        value={formik.values.rangoymin}
        placeholder="-1000"
        error={formik.touched.rangoymin && Boolean(formik.errors.rangoymin)}
        helperText={formik.touched.rangoymin && formik.errors.rangoymin}
        FormHelperTextProps={{ style: { color: 'red' } }}
        inputProps={{ maxLength: 24 }}
        InputLabelProps={{
          classes:{
            root: styles.label,
            shrink: styles["label-shrinked"]
          }
        }}
        style={{width: '30%'}}
        />

        <TextField
        name="rangoymax"
        label="Límite máximo serie y*"
        variant="outlined"
        size="small"
        fullWidth={true}
        onBlur={formik.handleBlur}
        onChange={handleChangeAAA}
        value={formik.values.rangoymax}
        placeholder="1000"
        error={formik.touched.rangoymax && Boolean(formik.errors.rangoymax)}
        helperText={formik.touched.rangoymax && formik.errors.rangoymax}
        FormHelperTextProps={{ style: { color: 'red' } }}
        inputProps={{ maxLength: 24 }}
        InputLabelProps={{
          classes:{
            root: styles.label,
            shrink: styles["label-shrinked"]
          }
        }}
        style={{width: '30%'}}
        />
      </div>

    </div>
  );
}

//default component
function DefaultComponent() {
  return <div>Algo salió mal, intenta seleccionando otra opción</div>;
}

const filterColumns = (
  array: string[],
  condition: (item: string, index: number, array: string[]) => boolean
): string[] => {
  return array.filter(condition);
};

export default ExtraFileds; 